module.exports = __webpack_public_path__ + "static/media/Icon_menu_login.ff6315f5.svg";